import { render } from "./ImageInput.vue?vue&type=template&id=4f54e46a&scoped=true"
import script from "./ImageInput.vue?vue&type=script&lang=js"
export * from "./ImageInput.vue?vue&type=script&lang=js"

import "./ImageInput.vue?vue&type=style&index=0&id=4f54e46a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f54e46a"]])

export default __exports__